var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconUpload"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 18.5C3 20.1569 4.34315 21.5 6 21.5H18C19.6569 21.5 21 20.1569 21 18.5V17C21 16.4477 20.5523 16 20 16C19.4477 16 19 16.4477 19 17V18.5C19 19.0523 18.5523 19.5 18 19.5H6C5.44772 19.5 5 19.0523 5 18.5V17C5 16.4477 4.55228 16 4 16C3.44772 16 3 16.4477 3 17V18.5ZM12 16.5C12.5523 16.5 13 16.0523 13 15.5V6.74536L16.331 9.74329C16.7415 10.1128 17.3738 10.0795 17.7433 9.66896C18.1128 9.25845 18.0795 8.62616 17.669 8.25671L12.669 3.75671C12.2887 3.41443 11.7113 3.41443 11.331 3.75671L6.33104 8.25671C5.92053 8.62616 5.88725 9.25845 6.25671 9.66896C6.62616 10.0795 7.25845 10.1128 7.66896 9.74329L11 6.74536V15.5C11 16.0523 11.4477 16.5 12 16.5Z",
    fill: "#002CFB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUpload);
export default __webpack_public_path__ + "static/media/iconUpload.ef7391436194e618d7238ed86396da76.svg";
export { ForwardRef as ReactComponent };